/* unplugin-vue-components disabled */import { render } from "./SubPoolInduction.vue?vue&type=template&id=4c4a8f96"
import script from "./SubPoolInduction.vue?vue&type=script&lang=js"
export * from "./SubPoolInduction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__